var _line, _line2, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesToys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 91,
    viewBox: "0 0 109 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 0.5,
    x2: 109,
    y2: 0.5,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 90.5,
    x2: 20,
    y2: 90.5,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7074 5.90698H21.27C17.3834 5.90698 14.9542 8.33614 14.9542 12.2228V47.2026C14.9542 51.0893 17.3834 53.5184 21.27 53.5184H57.7074C61.594 53.5184 64.0232 51.0893 64.0232 47.2026V12.2228C64.0232 8.33614 61.594 5.90698 57.7074 5.90698Z",
    fill: "#EA5A5A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.42,
    cy: 16.1077,
    r: 3.88665,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.043,
    cy: 16.1077,
    r: 3.88665,
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.42,
    cy: 29.7136,
    r: 3.88665,
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.043,
    cy: 29.7136,
    r: 3.88665,
    fill: "#333333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.42,
    cy: 43.3445,
    r: 3.38665,
    fill: "#333333",
    stroke: "#E11E26"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.043,
    cy: 43.3445,
    r: 3.88665,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3128 36.0145H51.8755C49.8267 36.0145 48.111 36.6569 46.9065 37.8614C45.7021 39.0659 45.0597 40.7816 45.0597 42.8303V77.8102C45.0597 79.8589 45.7021 81.5746 46.9065 82.7791C48.111 83.9836 49.8267 84.626 51.8755 84.626H88.3128C90.3616 84.626 92.0773 83.9836 93.2818 82.7791C94.4863 81.5746 95.1286 79.8589 95.1286 77.8102V42.8303C95.1286 40.7816 94.4863 39.0659 93.2818 37.8614C92.0773 36.6569 90.3616 36.0145 88.3128 36.0145Z",
    fill: "#EADDDD",
    stroke: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.54,
    cy: 50.1197,
    r: 3.88665,
    fill: "#333333"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8516,
    cy: 60.808,
    r: 3.88665,
    fill: "#333333"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1631,
    cy: 71.5236,
    r: 3.88665,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesToys);
export default __webpack_public_path__ + "static/media/categoriesToys.71014b051483c09e73d35e757b6a705d.svg";
export { ForwardRef as ReactComponent };